export default __webpack_public_path__ + "static/media/skf_sealing.12bdb540.png";